"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountShortSchema = void 0;
const zod_1 = require("zod");
const image_file_1 = require("./image-file");
const account_stats_1 = require("./account-stats");
exports.accountShortSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  /** Уникальный код для формирования ссылки */
  slug: zod_1.z.string(),
  /** Имя */
  first_name: zod_1.z.string(),
  /** Фамилия */
  last_name: zod_1.z.string(),
  /** Аватара */
  userpic_id: zod_1.z.string().uuid().optional(),
  userpic: zod_1.z.record(image_file_1.imageFileSchema).optional(),
  /** Пользовательская статистика */
  stats: account_stats_1.AccountStatsSchema.partial().optional()
});
